import * as TYPES from './capability-actiontypes';
import { mapModules } from './capability-mapper';
import { getCapabilities, getSystemCapabilities, getSupportedLanguages } from './capability-api';
import * as MsgBarActions from '../system-shared/message-bar-action-creator';

export const capabilityLoaded = (response) => {
  const state = {
    capabilities: mapModules(response),
  };

  return {
    type: TYPES.CAPABILITY_LOADED_SUCCESS,
    state,
  };
};

const capabilityLoadFailure = (message) => ({
  type: TYPES.CAPABILITY_LOADED_FAILURE,
  error: message,
});

export const loadCapabilities = (userId) => (dispatch) =>
  getCapabilities(userId).then(
    (response) => dispatch(capabilityLoaded(response.data)),
    (axiosResponse) => {
      const error = axiosResponse.response;
      dispatch(MsgBarActions.showErrorMessage());
      dispatch(capabilityLoadFailure(error.message));
    }
  );

export const systemCapabilityLoaded = (response) => {
  const state = {
    systemCapabilities: mapModules(response),
  };

  return {
    type: TYPES.SYSTEM_CAPABILITY_LOADED_SUCCESS,
    state,
  };
};

export const loadSystemCapabilities = () => (dispatch) =>
  getSystemCapabilities()
    .then(
      (response) => dispatch(systemCapabilityLoaded(response.data)),
      () => dispatch(MsgBarActions.showErrorMessage())
    );

export const supportedLanguagesLoaded = (response) => {
  const state = {
    languages: response,
  };

  return {
    type: TYPES.SUPPORTED_LANGUAGES_LOADED_SUCCESS,
    state,
  };
};

const supportedLanguagesLoadFailure = (message) => ({
  type: TYPES.SUPPORTED_LANGUAGES_LOADED_FAILURE,
  error: message,
});

export const loadSupportedLanguages = () => (dispatch) =>
  getSupportedLanguages().then(
    (response) => dispatch(supportedLanguagesLoaded(response.data)),
    (axiosResponse) => {
      const error = axiosResponse.response;
      dispatch(MsgBarActions.showErrorMessage());
      dispatch(supportedLanguagesLoadFailure(error.message));
    }
  );
